import { financeUrl } from '../../urls';

export const financeManageWorksheetsUrl = () => `${financeUrl()}/manage-worksheets`;

export const creditCheckUrl = () => `${financeUrl()}/credit-check`;

export const sendInvoicesUrl = () => `${financeUrl()}/send-invoices`;

export const worksheetsOnCreditHoldUrl = () => `${financeUrl()}/on-hold`;
